/*
 ** vue router: Leave
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtLeave: RouteRecordRaw = {
  path: '/eservices/leave',
  name: 'vrtLeave',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'submit',
      name: 'vrtLeaveSubmit',
      component: () => import('./vpgLeaveSubmit.vue'),
    },
    {
      path: 'view',
      name: 'vrtLeaveList',
      component: () => import('./vpgLeaveList.vue'),
    },
    {
      path: 'update',
      name: 'vrtLeaveUpdate',
      component: () => import('./vpgLeaveUpdate.vue'),
    },
    {
      path: 'details',
      name: 'vrtLeaveDetails',
      component: () => import('./vpgLeaveDetails.vue'),
    },
    {
      path: 'reporthr',
      name: 'vrtLeaveReportHR',
      component: () => import('./vpgLeaveReportHR.vue'),
    },
    {
      path: 'reportvo',
      name: 'vrtLeaveReportVO',
      component: () => import('./vpgLeaveReportVO.vue'),
    },
    {
      path: 'reportao',
      name: 'vrtLeaveReportAO',
      component: () => import('./vpgLeaveReportAO.vue'),
    },
    {
      path: 'reportco',
      name: 'vrtLeaveReportCO',
      component: () => import('./vpgLeaveReportCO.vue'),
    },
    {
      path: 'create',
      name: 'vrtLeaveCreate',
      component: () => import('./vpgLeaveCreate.vue'),
    },
    {
      path: 'edit',
      name: 'vrtLeaveEdit',
      component: () => import('./vpgLeaveEdit.vue'),
    },
    {
      path: 'balance',
      name: 'vrtLeaveEditBalance',
      component: () => import('./vpgLeaveEditBalance.vue'),
    },
    {
      path: 'bringforward',
      name: 'vrtLeaveEditBF',
      component: () => import('./vpgLeaveEditBF.vue'),
    },
    {
      path: 'offdays',
      name: 'vrtLeaveEditOffDays',
      component: () => import('./vpgLeaveEditOffDays.vue'),
    },
    {
      path: 'blackout',
      name: 'vrtLeaveBlackout',
      component: () => import('./vpgLeaveEditBlackout.vue'),
    },
    {
      path: 'admin',
      name: 'vrtLeaveAdmin',
      component: () => import('./vpgLeaveAdmin.vue'),
    },
    {
      path: 'pending',
      name: 'vrtLeavePending',
      component: () => import('./vpgLeavePending.vue'),
    },
    {
      path: 'summary',
      name: 'vrtLeaveSummary',
      component: () => import('./vpgLeaveSummary.vue'),
    },
    {
      path: 'summary',
      name: 'vrtLeaveSummaryByDate',
      component: () => import('./vpgLeaveSummaryByDate.vue'),
    },
    {
      path: 'limit',
      name: 'vrtLeaveLimitList',
      component: () => import('./vpgLeaveLimitList.vue'),
    },
    {
      path: 'limitops',
      name: 'vrtLeaveLimitOperate',
      component: () => import('./vpgLeaveLimitOperate.vue'),
    },
  ],
};

export default vrtLeave;
